var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"local-body d-flex justify-center align-center"},[_c('div',{staticStyle:{"position":"relative"}},[_c('hero-text'),_c('div',{staticClass:"d-flex justify-end",staticStyle:{"z-index":"99"}},[_c('a',{on:{"click":_vm.onClickNext}},[_vm._v("Next")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }